import { AfterViewInit, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Subject } from 'rxjs';
import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';

@Component({
    selector: 'website-redirect-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
})
export class WebsiteRedirectListComponent extends AbstractListComponent implements OnInit, AfterViewInit {
    private devices: any;
    addSubject: Subject<any> = new Subject();

    constructor(
        httpClient: HttpClient,
        toastrService: ToastrService,
        router: Router,
        route: ActivatedRoute,
        urlBuilder: AdminUrlBuilder,
        private breadcrumbBuilder: BreadcrumbBuilder
    ) {
        super(httpClient, toastrService, router, route, urlBuilder);
    }

    ngOnInit(): void {
        this.breadcrumbBuilder.clear();
        this.breadcrumbBuilder.add({
            label: 'Website redirects',
            url: '/redirects',
        });

        super.ngOnInit();

        this.addSubject.subscribe(() => {
            this.load();
        });
    }

    ngAfterViewInit(): void {
        this.getDevices();
    }

    getResourceUrl(): string {
        return '/website-redirect';
    }

    protected getUrl(): string {
        const params = this.route.snapshot.params;
        return '/website-redirect' + (params.id ? '/' + params.id : '');
    }

    getDevices(): void {
        this.httpClient.get(this.urlBuilder.buildUrl(this.getResourceUrl())).subscribe(
            (response: any) => {
                this.devices = response;
            },
            (error: any) => {
                this.toastrService.error('Unable to load redirects');
            }
        );
    }

    add() {
        this.pagination.rows.unshift({});
    }

    edit(redirect) {
        redirect.__editing = true;
    }

    save(redirect) {
        this.httpClient.put(`${this.urlBuilder.buildUrl(this.getResourceUrl())}/${redirect.id}`, redirect).subscribe(
            (response: any) => {
                this.toastrService.success('Saved');
                redirect.__editing = false;
            },
            (error: any) => {
                this.toastrService.error('Unable to save redirect');
            }
        );
    }

    cancel(device) {
        device.__editing = false;
    }
}
